<template>
  <div class="place_order" id="place_order">
    <div class="header" :class="$store.state.userPhone==''?'blue':''">
      <hea-der v-if="$store.state.userPhone==''?false:true"></hea-der>
      <head-top v-else></head-top>
    </div>
    <div class="place_main">
      <!-- <steps :stepNum="stepNumber" v-if="stepNumber"></steps> -->
      <steps></steps>
      <el-alert type="warning" class="alert_info" v-if="!$store.state.userPhone">
        <svg class="icon iconhome_notice" aria-hidden="true">
          <use xlink:href="#iconhome_notice" />
        </svg>您还未登录，登录后发布订单更有保障哦
        <el-button type="warning" class="handle" @click="goLogin()">立即登录</el-button>
      </el-alert>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
      <!-- <keep-alive>
        <component v-bind:is="currentTabComponent"></component>
      </keep-alive>-->
    </div>
  </div>
</template>

<script>
import Bus from "./../../utils/bus.js";
import heaDer from "./../../components/user/header";
import headTop from "./../../components/headTop";
import steps from "./../../components/user/steps";
export default {
  components: {
    heaDer,
    steps,
    headTop
  },
  data() {
    return {
      // stepNumber: 1,
      // currentTabComponent:"stepOne"
    };
  },
  created() {
    var _this = this;
    Bus.$on("val", data => {
      _this.currentTabComponent = data.url;
      _this.stepNumber = data.step;
    });
  },
  // mounted() {
  //   var _this = this;
  //   Bus.$on('val', (data) => {
  //       _this.currentTabComponent = data.url
  //       _this.stepNumber = data.step
  //     })

  // },

  methods: {
    // 去登录
    goLogin() {
      // console.log(this.$route.path)
      this.$store.state.defaultUrl=this.$route.path
      this.$router.push({ path: "/login" });
    },
  }
};
</script>
<style lang="scss">
#place_order {
  .bot_selected {
    color: #fff !important;
    border-bottom: none !important;
  }
  .bot_selected:hover {
    // color: #3455d3 !important;
    border-bottom: 2px solid #fff !important;
  }
}
</style>
<style lang='scss' scoped>
.place_order {
  background: #eef0f3;
  overflow: hidden;
}
.header {
  height: 90px;
}
.blue {
  background: #3455d3 !important;
  .headDefault {
    transition: 0s;
    background: #3455d3 !important;
  }
}
.place_main {
  width: 1200px;
  margin: 0 auto;
  margin-top: 15px;
  margin-bottom: 100px;
}
.place_order {
  &/deep/ .alert_info {
    background: #fff2da;
    border: 1px solid #ffad16;
    // margin: 10px 0;
    height: 40px;
    padding: 0;
    color: #ffad16;
    font-size: 14px;
    border-radius: 2px;
    display: flex;
    align-items: stretch;
    margin-top: 15px;
    .el-alert__description {
      display: flex;
      align-items: center;
      margin: 6px 0 0;
    }
    .iconhome_notice {
      width: 22px;
      height: 22px;
      color: #ffad16;
      margin-right: 5px;
    }
    .handle {
      width: 72px;
      height: 24px;
      background: rgba(255, 173, 22, 1);
      border-radius: 2px;
      font-size: 12px;
      line-height: 0;
      display: flex;
      justify-content: center;
      margin-left: 30px;
    }
    .handle:hover {
      background: rgba(255, 187, 63, 1);
    }
  }
  &/deep/ .alert_info {
    // .el-alert__description {
    //   display: flex;
    //   align-items: center;
    //   margin: 6px 0 0;
    // }
    .el-alert__closebtn {
      font-size: 22px;
      color: #ffad16 !important;
      top: 10px;
    }
  }
}
</style>